module.exports = __webpack_public_path__ + "img/jgdj.49de5206.png";